<template>
  <div class="home-view internal">
    <section class="-content">
      <div class="container">
        <h1 class="title-default">Status de obra</h1>

        <div class="crono">
          <div class="left">
            <div class="top">
              <p v-for="item of percents" :key="item">{{ item }}%</p>
            </div> <!-- /.top -->

            <div class="bottom">
              <div class="steps">
                <div class="step"  v-for="item of statusEmp" :key="item.key">
                  <p>{{ item.title }}</p>

                  <div class="progress">
                    <div
                      :style="{
                        width: hidePercentStatus ? '0' : statusExibido[item.key] + '%'
                      }"
                    />
                  </div> <!-- /.progress -->
                </div>
              </div>
            </div> <!-- /.bottom -->
          </div> <!-- /.left -->

          <div class="right">
            <h2>Cronograma geral:</h2>

            <div class="circle">
              <div class="single-chart">
                <svg viewBox="0 0 36 36" class="circular-chart orange">
                  <path class="circle-bg"
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                  <path class="circle"
                    :stroke-dasharray="(hidePercentStatus ? 0 : statusExibido.cronogramaGeral) + ', 100'"
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                  <text x="18" y="20.35" class="percentage">
                    {{ statusExibido.cronogramaGeral }}%
                  </text>
                </svg>
              </div>

              <!-- <h3>{{ statusExibido.cronogramaGeral }}%</h3> -->
            </div>
          </div>
        </div> <!-- /.crono -->
      </div> <!-- /.container -->
    </section> <!-- /.-content -->

    <section class="emp-gallery -top" v-if="statusExibido.id">
      <div class="container">
        <div class="top-container">
          <div class="tabs">
            <p class="-active" v-if="temFotos">
              <a href="javascript:void(0)" class="name">
                Empreendimento
                <span @click="toggleModal">{{ fotosStatus.length }}</span>
              </a>
            </p> <!-- /p -->
          </div> <!-- /.tabs -->
          <div class="status-date">
            <div class="select-month" @click="showDropDown = !showDropDown">
              <h6 class="aligncenter">
                Fotos de
                <span class="current-month">{{ statusExibido.mesReferenciaNome }} {{ statusExibido.anoReferencia }}</span>
              </h6>

              <div class="dropdown" @click="showDropDown = !showDropDown" :class="{ '-active': showDropDown }">
                <a href="javascript:void(0)" @click="loadStatus(item.id)" v-for="(item, i) in dropdown" :key="i">{{ item.mesReferenciaNome }} {{ item.anoReferencia }}</a>
              </div>
            </div> <!-- /.select-month -->
          </div>
        </div> <!-- /.top-container -->
      </div>
    </section>

    <section class="emp-gallery -empty" v-if="statusExibido.id && !temFotos">
      <div class="container">
        <p class="sem-fotos">Sem fotos para este mês</p>
      </div>
    </section> <!-- /.-empty -->

    <section class="slide-status" v-if="temFotos">
      <a href="javascript:void(0)" class="btn-carousel -prev" @click="prevStatus()" :class="{ '-deactivated': activeIndex == 0 }"><i class="icon -arrow-left-red"></i></a>
      <div class="container">
        <swiper ref="swiperStatus" :options="swiperOpts" @slideChange="slideChangedStatus()">
          <template>
            <swiper-slide v-for="(item, i) in fotosStatus" :key="i">
              <figure>
                <a href="javascript:void(0)" class="icon -zoom-white" @click="toggleModal"></a>

                <img :src="urlFiles + 'cliente/status-obra/' + item.foto" :alt="item.legenda">
              </figure>
            </swiper-slide>
          </template>
        </swiper>
      </div>

      <a href="javascript:void(0)" class="btn-carousel -next" @click="nextStatus()" :class="{ '-deactivated': activeIndex == fotosStatus.length - 1 }"><i class="icon -arrow-right-red"></i></a>
    </section> <!-- /.slide-status -->

    <section class="emp-gallery" v-if="temFotos">
      <div class="container">
        <div class="bottom-container">
          <ul>
            <li v-for="(item, index) in fotosStatus" :key="item.id" :class="{ '-active': index === activeIndex }" @click="slideToStatus(index)"></li>
          </ul>
        </div>
      </div>
    </section>

    <transition name="fade">
      <Modal :data="optsModal" @close="toggleModal()" v-if="optsModal.render" />
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import PagesService from '@/services/Pages'
import Modal from '@/components/Modal'
import { normalizarStatus } from '@/utils/statusObra'

export default {
  name: 'status-obra',

  components: {
    Modal
  },

  data () {
    const data = {
      percents: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      hidePercentStatus: true,

      optsModal: {
        type: 'GALLERY',
        urlBase: 'cliente/status-obra/',
        show: true,
        render: false,
        activeIndex: 0
      },

      model: {
        statusAtual: {}
      },

      dropdown: [],
      empInfo: {},
      statusEmp: [],

      statusId: 0,
      showDropDown: false,

      urlFiles: Vue.prototype.urlFiles,

      activeIndex: 0,
      swiperOpts: {
        autoHeight: true
      },

      status: {
        options: {
          autoHeight: true
        },

        activeIndex: 0
      }, // status

      STATUS_RESID: [
        { title: 'Terraplanagem', key: 'terraplanagem' },
        { title: 'Fundação', key: 'fundacao' },
        { title: 'Estruturas', key: 'estrutura' },
        { title: 'Vedações', key: 'vedacao' },
        { title: 'Instalações', key: 'instalacao' },
        { title: 'Fachada', key: 'fachada' },
        { title: 'Acabamentos', key: 'acabamento' },
        { title: 'Finalização', key: 'finalizacao' }
      ],

      STATUS_CORP: [
        { title: 'Terraplanagem', key: 'terraplanagem' },
        { title: 'Fundação', key: 'fundacao' },
        { title: 'Estruturas', key: 'estrutura' },
        { title: 'Vedações', key: 'vedacao' },
        { title: 'Instalações', key: 'instalacao' },
        { title: 'Fachada', key: 'fachada' },
        { title: 'Acabamentos', key: 'acabamento' },
        { title: 'Finalização', key: 'finalizacao' }
      ],

      STATUS_URBANISMO: [
        { title: 'Terraplanagem', key: 'terraplanagem' },
        { title: 'Rede de drenagem', key: 'redeDrenagem' },
        { title: 'Rede de água potável', key: 'redeAguaPotavel' },
        { title: 'Rede de esgoto', key: 'redeEsgoto' },
        { title: 'Guias e Sarjetas', key: 'guia' },
        { title: 'Pavimentação', key: 'pavimentacao' },
        { title: 'Rede de Iluminação Pública ', key: 'redeIluminacaoPublica' },
        { title: 'Paisagismo e Equipamentos', key: 'paisagismo' },
        { title: 'Calçadas', key: 'calcada' },
        { title: 'Sinalização Vertical e Horizontal', key: 'sinalizacao' },
        { title: 'Finalização', key: 'finalizacao' }
      ]
    }

    return data
  }, // data()

  beforeMount () {
    this.loadList(this.statusId)
  }, // beforeMount()

  mounted () {
  }, // mounted()

  methods: {
    async loadList (statusId) {
      let { empreendimentoIdWeb } = this.$store.state.contratoAtual

      const promises = [PagesService.getStatus(empreendimentoIdWeb), PagesService.getStatusDetalhe(empreendimentoIdWeb, statusId)]

      return Promise.all(promises).then(res => {
        this.dropdown = res[0]
        this.model = res[1]

        this.optsModal.arr = this.fotosStatus

        this.statusEmp = this.getFields((this.statusExibido.empreendimento || {}).tipo)

        setTimeout(() => {
          this.hidePercentStatus = false
        }, 400)
      }).catch(e => {
        console.error('Falha ao recuperar status', e)
      })
    }, // loadList()

    getFields (tipo) {
      const obj = {
        residencial: this.STATUS_RESID,
        comercial: this.STATUS_CORP,
        loteamento: this.STATUS_URBANISMO
      }

      return obj[tipo] || []
    }, // getFields()

    async loadStatus (statusId) {
      this.showDropDown = false

      try {
        let { empreendimentoIdWeb } = this.$store.state.contratoAtual

        let xhr = await PagesService.getStatusDetalhe(empreendimentoIdWeb, statusId)

        this.model = xhr
        this.empInfo = xhr.empreendimento

        this.activeIndex = 0
        this.optsModal.activeIndex = 0
        this.optsModal.arr = this.fotosStatus
      } catch (e) {
        console.error('Falha ao recuperar status', e)
      }
    }, // loadStatus()

    toggleModal (i) {
      this.optsModal.render = !this.optsModal.render
    }, // toggleModal()

    slideChangedStatus () {
      this.activeIndex = this.swiperStatus.activeIndex
      this.optsModal.activeIndex = this.activeIndex
    }, // slideChangedStatus()

    prevStatus () {
      this.swiperStatus.slidePrev()
    }, // prevStatus()

    nextStatus () {
      this.swiperStatus.slideNext()
    }, // nextStatus()

    isMobile () {
      return screen.width <= 1024
    }, // isMobile()

    slideToStatus (i) {
      this.swiperStatus.slideTo(i)
    } // slideTo()
  }, // methods

  computed: {
    // Registro de status realmente exibido — as fotos precisam sair daqui, e não
    // de `fotosRecentes` (que é o último mês COM fotos, nem sempre o mês atual).
    statusExibido () {
      return normalizarStatus(this.model).status
    }, // statusExibido()

    fotosStatus () {
      return normalizarStatus(this.model).fotos
    }, // fotosStatus()

    temFotos () {
      return this.fotosStatus.length > 0
    }, // temFotos()

    swiperStatus () {
      return this.$refs.swiperStatus.swiper
    } // swiperStatus()
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  section
    &.slide-status
      .btn-carousel
          display: none;

    &.-content
      .crono
        $leftSize: 270px
        +box-border
        padding: 40px 70px 30px
        display: flex
        align-items: flex-start
        flex-direction: row
        justify-content: space-between

        .left
          width: calc(100% - 250px)
          overflow: hidden

          .top
            display: flex
            flex-direction: row
            flex-wrap: wrap
            width: calc(100% - #{$leftSize})
            margin-left: $leftSize
            position: relative

            p
              width: 10%
              position: relative
              font-size: 12px
              display: block
              text-align: left
              text-indent: -10px

              &:nth-of-type(2)
                margin-left: 10%

              &:first-of-type,
              &:last-of-type
                position: absolute

              &:last-of-type
                right: 0
                text-align: right

                &:after
                  left: initial
                  right: 0

              &:after
                content: ''
                width: 1px
                height: 1000px
                background: rgba(#666, 0.2)
                position: absolute
                top: calc(100% + 18px)
                left: 0

          .bottom
            display: flex
            flex-direction: row

            .steps
              width: 100%

              > div:last-of-type
                margin-bottom: -8px

                .progress
                  margin-bottom: -15px

                  div
                    top: -1px

              .step
                display: flex
                flex-direction: row
                align-items: center
                padding-bottom: 2px;

                p
                  text-transform: uppercase
                  font-size: 14px
                  letter-spacing: 0px
                  padding: 6px 0
                  width: $leftSize

                .progress
                  width: calc(100% - #{$leftSize})
                  position: relative

                  &:after
                    content: ''
                    position: absolute
                    top: 50%
                    transform: translateY(-50%)
                    height: 1px
                    width: 100%
                    background: rgba(#666, 0.2)

                  div
                    transition: all 2000ms ease
                    position: relative
                    top: 2px
                    width: 0%
                    height: 5px
                    background: map-get($colors, primary)

        .right
          width: 200px

          h2
            text-align: center
            font-size: 19px
            letter-spacing: 1px
            margin-bottom: 20px

          .single-chart
            width: 100%
            justify-content: space-around

          .circular-chart
            display: block
            margin: 10px auto
            max-width: 80%
            max-height: 250px

          .circle-bg
            fill: none
            stroke: #eee
            stroke-width: 1.5

          .circle
            fill: none
            stroke-width: 1
            stroke-linecap: round
            animation: progress 1s ease-out forwards

          @keyframes progress
            0%
              stroke-dasharray: 0 100

          .circular-chart.orange .circle
            stroke: map-get($colors, primary)

          .percentage
            fill: #000
            font-family: sans-serif
            font-size: 0.5em
            text-anchor: middle

    &.slide-status
      /deep/ .swiper-wrapper
        height: 100% !important

    &.emp-gallery
      margin: 0 auto
      padding: 60px 0
      position: relative

      &.-top
        padding: 60px 0 0
        z-index: 500

      &.-empty
        padding: 40px 0 60px

        .sem-fotos
          +box-border
          padding: 40px 20px
          text-align: center
          font-size: 16px
          color: rgba(#666, 0.8)

      .container
        position: relative

        .swiper-content
          position: relative

        .top-container
          padding: 0
          pointer-events: none
          display: flex
          justify-content: space-between
          align-items: center

          &:before
            content: ''
            width: 100%
            height: 100%
            position: absolute
            z-index: -1
            bottom: 0
            left: 0
            pointer-events: none

          .tabs
            display: flex
            align-items: center
            justify-content: flex-start

            p
              text-transform: uppercase
              color: #000
              cursor: pointer
              pointer-events: all
              position: relative
              padding: 5px 10px 5px 35px

              *,
              *:after,
              *:before
                // transition: all 200ms ease

              &.-active,
              &:hover
                border-color: transparent
                background: map-get($colors, primary)

                a
                  color: #fff

                  &:after
                    opacity: 1

              a
                font-size: 25px
                font-weight: 500
                display: inline-block

                &:after
                  content: ''
                  position: absolute
                  left: 100%
                  top: 0
                  width: 0
                  height: 0
                  // transition: all 90ms ease
                  border-top: 44px solid map-get($colors, primary)
                  opacity: 0
                  border-right: 35px solid transparent

                span
                  position: relative
                  top: -3px
                  font-size: 14px
                  font-weight: 500
                  background-color: #fff
                  color: map-get($colors, primary)
                  padding: 5px 11px 3px
                  border-radius: 100px
                  margin-left: 5px

                  &:before
                    content: ''
                    display: inline-block
                    background-image: url(~/images/icons/foto.png)
                    background-repeat: no-repeat
                    background-size: contain
                    background-position: center
                    width: 18px
                    height: 14px
                    top: 2px
                    margin-right: 5px
                    position: relative

                  span
                    position: relative
                    top: -2px

          .status-date
            p
              text-transform: uppercase

            .select-month
              pointer-events: all
              height: 44px;
              padding: 0 135px 0 50px
              position: relative
              background-color: lighten(map-get($colors, gray), 10%)
              color: #fff
              text-transform: uppercase
              top: -10px
              left: 0
              transform: translateX(0)
              z-index: 10000
              display: flex
              align-items: center
              border-radius: 5px
              cursor: pointer

              &:after
                content: ''
                display: block
                position: absolute
                top: 50%
                transform: translateY(-50%)
                right: 14px
                z-index: 10
                width: 0
                height: 0
                border-style: solid
                border-width: 12px 7.5px 0 7.5px
                border-color: #ddd transparent transparent transparent

              h6
                color: #fff
                font-weight: 400
                text-transform: uppercase
                font-size: 16px
                letter-spacing: 2px
                position: relative
                z-index: 10
                @extend %no-select

                span.current-month
                  letter-spacing: 0
                  font-weight: 700
                  color: #FFF
                  border-radius: 0
                  white-space: nowrap

                  i
                    position: relative
                    margin-left: 5px
                    top: 3px

              .dropdown
                width: 100%;
                background-color: map-get($colors, gray) !important
                color: #fff
                text-transform: uppercase
                position: absolute
                right: 0
                z-index: 5
                background: #fff
                top: calc(100% - 5px)
                min-width: 178px
                border-radius: 0 0 5px 5px
                max-height: 0
                overflow: hidden
                transition: all 150ms ease

                &.-active
                  padding: 10px
                  box-shadow: 0px 3px 13px rgba(#000, 0.5)
                  max-height: 200px

                a
                  display: block
                  line-height: 25px
                  transition: color .3s ease
                  @extend %no-select

                  &:hover
                    color: map-get($colors, primary)

        .bottom-container
          position: absolute
          right: 0
          left: 0
          bottom: 0
          pointer-events: none
          text-align: center
          z-index: 100
          padding: 0

          .caption
            right: 0
            bottom: 0
            position: absolute
            padding: 10px
            text-transform: uppercase
            color: #fff
            font-weight: 600
            background-color: rgba(#000, .5)

          ul
            display: inline-block
            // border-bottom: 2px solid  #fff
            // padding-bottom: 5px
            // margin-bottom: 25px
            min-height: 27px
            position: relative
            bottom: 20px

            li
              display: inline-block
              width: 11px
              height: 11px
              margin-right: 7px
              background: #ccc
              cursor: pointer
              transition: all 200ms ease
              pointer-events: all

              &:last-of-type
                margin-right: 0

              &:hover,
              &.-active
                background: map-get($colors, primary)
                height: 11px

  @media (max-width: 1024px)
    section
      &.-content
        padding-bottom: 0 !important

        .crono
          padding: 20px
          flex-direction: column

          .left
            width: 100%
            overflow: visible

            .top
              display: none

            .bottom
              .steps
                .step
                  position: relative

                  p
                    font-size: 13px
                    letter-spacing: 0
                    margin-bottom: 15px

                  .progress
                    position: absolute
                    left: 0
                    top: calc(100% - 15px)
                    width: 100%

          .right
            width: 100%
            max-width: 300px
            margin: 40px auto 0

      &.emp-gallery
        margin-top: 20px

        &:last-of-type
          padding: 60px 0 0

          .bottom-container
            ul
              bottom: 15px

        .top-container
          position: relative

          .tabs
            display: none !important

          .status-date
            width: 90%
            position: absolute
            top: 10px
            left: 50%
            transform: translateX(-50%)

            .select-month
              top: -60px !important
              padding: 0 50px 0 30px !important

              h6
                .current-month
                  font-weight: 400 !important

        &:last-of-type
          display: none

      &.slide-status
        .btn-carousel
          display: block !important

        .container
          padding: 0

          .icon
            &.-zoom-white
              opacity: 1 !important
              background-size: 34px
              background-color: rgba(0, 0, 0, 0.5)
</style>
